// MODULES
import React from "react";

// COMPONENTS
import TextField from "@components/TextField/TextField";


export default class EditableField extends React.PureComponent {
	static defaultProps = {
		Component: TextField
	};

	render() {
		const {props} = this;
		const {Component, onChange, onBlur} = props;

		return (
			<Component {...props} autoComplete={false} onChange={onChange ? this._onChange : undefined}
					   onBlur={onBlur ? this._onBlur : undefined}/>
		);
	}

	// Internal methods
	_onChange = (value) => {
		const {name, onChange} = this.props;
		if (onChange) {
			onChange(name, value);
		}
	};

	_onBlur = () => {
		const {name, onBlur} = this.props;
		if (onBlur) {
			onBlur(name);
		}
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/EditableField/EditableField.js